import React, { useState } from "react";
import { MOCK_SEARCH } from "../mock/flightEngineMockData";
import "./FlightSearchScreen.css";

export default function FlightSearchScreen({ initialSearch = MOCK_SEARCH, onSearch }) {
  const [form, setForm] = useState(initialSearch);

  const setField = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <section className="fe2-search" aria-label="חיפוש טיסות">
      <div className="fe2-search__card">
        <div className="fe2-search__trip">
          <button
            type="button"
            className={
              form.tripType === "roundtrip"
                ? "fe2-search__chip fe2-search__chip--active"
                : "fe2-search__chip"
            }
            onClick={() => setField("tripType", "roundtrip")}
          >
            הלוך־חזור
          </button>
          <button
            type="button"
            className={
              form.tripType === "oneway"
                ? "fe2-search__chip fe2-search__chip--active"
                : "fe2-search__chip"
            }
            onClick={() => setField("tripType", "oneway")}
          >
            הלוך
          </button>
        </div>

        <div className="fe2-search__grid">
          <label className="fe2-field">
            <span className="fe2-field__label">מוצא</span>
            <input
              className="fe2-field__input fe2-ltr"
              value={form.origin}
              onChange={(e) => setField("origin", e.target.value.toUpperCase())}
            />
          </label>
          <label className="fe2-field">
            <span className="fe2-field__label">יעד</span>
            <input
              className="fe2-field__input fe2-ltr"
              value={form.destination}
              onChange={(e) =>
                setField("destination", e.target.value.toUpperCase())
              }
            />
          </label>
          <label className="fe2-field">
            <span className="fe2-field__label">תאריך יציאה</span>
            <input
              type="date"
              className="fe2-field__input fe2-ltr"
              value={form.departDate}
              onChange={(e) => setField("departDate", e.target.value)}
            />
          </label>
          <label className="fe2-field">
            <span className="fe2-field__label">תאריך חזרה</span>
            <input
              type="date"
              className="fe2-field__input fe2-ltr"
              value={form.returnDate}
              disabled={form.tripType === "oneway"}
              onChange={(e) => setField("returnDate", e.target.value)}
            />
          </label>
          <label className="fe2-field">
            <span className="fe2-field__label">נוסעים</span>
            <input
              className="fe2-field__input"
              value={`${form.passengers.adults} מבוגרים`}
              readOnly
            />
          </label>
          <label className="fe2-field">
            <span className="fe2-field__label">מחלקה</span>
            <select
              className="fe2-field__input"
              value={form.cabin || ""}
              onChange={(e) => setField("cabin", e.target.value)}
            >
              <option value=""></option>
              <option value="economy">Economy</option>
              <option value="premium">Premium</option>
              <option value="business">Business</option>
            </select>
          </label>
        </div>

        <div className="fe2-search__actions">
          <button
            type="button"
            className="fe2-btn fe2-btn--primary"
            onClick={() => onSearch?.(form)}
          >
            חפש טיסות
          </button>
        </div>
      </div>
    </section>
  );
}
